import { APP_BASE_HREF } from '@angular/common';
import { inject } from '@angular/core';
import { Canal, ContextService, CustomWindow, provideBaseHref } from '@bcef/ia-shared';
import { WA_WINDOW } from '@ng-web-apis/common';

export const environment = {
  production: true,
  providers: [
    provideBaseHref(),
    {
      provide: APP_BASE_HREF,
      useFactory: (): string | void => {
        const window = inject<CustomWindow>(WA_WINDOW);
        const context = inject(ContextService);

        if (window.APPS_BASE_HREF && window.CANAL === Canal.DESKTOP) {
          return window.APPS_BASE_HREF;
        }
        // Temporary fix for webview
        window.document.body.classList.add(context.typology);
        return `${window.APPS_BASE_HREF}.html`;
      },
    },
  ],
};
